import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types'
import {Helmet} from 'react-helmet';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import SectionTitle from "../../../Layout/components/SectionTitle";
import DashboardEventsList from "./DashboardEventsList";
import DashboardEventsSearch from "./DashboardEventsSearch";
import {withLocalize, Translate} from 'react-localize-redux';
import translations from '../../translations/translations_events';

class DashboardEventsListContainer extends Component {
    state = {
        filter: 'checkedin'
    };

    constructor(props) {
        super(props);

        this.props.addTranslation(translations);
    }

    changeFilter = (selectedFilter) => {
        this.setState({filter: selectedFilter});
    };

    render() {
        const pageTitle = this.props.translate('dashboard_events.page_title') + ' ' + process.env.REACT_APP_HEAD_TITLE_SEPARATOR + ' ' + process.env.REACT_APP_SITE_TITLE;

        return (
            <Fragment>
                <Helmet
                    bodyAttributes={{
                        class: 'dashboard'
                    }}
                >
                    <title>{pageTitle}</title>
                </Helmet>
                <div className="container">
                    <SectionTitle cssClass="page-title"
                                  title={this.props.translate('dashboard_events.page_title')}
                                  subtitle={this.props.translate('dashboard_events.page_description')}
                    />

                    <div className="mt-90 mb-90">
                        <DashboardEventsSearch changeFilter={this.changeFilter} filter={this.state.filter} />
                        <DashboardEventsList changeFilter={this.changeFilter} filter={this.state.filter} />
                    </div>
                </div>
            </Fragment>
        );
    }
}

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default withRouter(connect(mapStateToProps, {})(withLocalize(DashboardEventsListContainer)));



// WEBPACK FOOTER //
// ./src/features/Dashboard/components/Events/DashboardEventsListContainer.js